import React, { memo, useCallback, useEffect, useState } from "react";

import { FieldValues, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import { TextsProps } from "../../../database/txt.interface";

import FotoPerfil from "../../../components/FotoPerfil";
import Text from "../../../components/Texts/Text";
import Form from "../../../components/Form/index";
import InputTextEntryForm from '../../../components/Inputs/inputForm';
import InputSelectForm from '../../../components/SelectComponent/InputSelectForm';
import FormSubmiteButton from "../../../components/Buttons/FormSubmitButton";


import { Background, ContainerButtons, ContainerTwoLabels, Conteiner, Content, Margem, Header, ButtonFooter } from "./styles";
import * as Sentry from "@sentry/react";

import { Colors } from "../../../styles/colors";

import BackgroundRegister from "../../../assets/kinologyIcons/png/BackgrounLogin.png";
import LogoLogin from "../../../assets/kinologyIcons/svg/LogoLogin.svg";
import LogoHeader from "../../../assets/kinologyIcons/svg/LogoHeader.svg";
import Cafe from "../../../assets/kinologyIcons/png/cafe.png";
import Exercicio from "../../../assets/kinologyIcons/png/exercicio.png";
import Roupas from "../../../assets/kinologyIcons/png/roupas.png";
import { RadioButton } from "../../../styles/global";
import moment from "moment";
import { useParams } from "react-router-dom";
import axios from "axios";
import { formatDominantForSave, sendErrorSentryOrLocalHost } from "../../../utils/funcs";
import { AmplitudeLog } from "../../../utils/amplitude";
import { AppActions } from "../../../store/ducks/app";
import { TypesErrorRequest } from "../../../utils/types";
import history from "../../../routes/history";
import { DashBoardActions } from "../../../store/ducks/dashboard";
interface Usuario {
	celular: string;
	cpf: string;
};

const CadastroPacienteAsync: React.FC = function () {
	const dispatch = useDispatch();
	const methods = useForm();
	const [aprovado, setAprovado] = useState(false);
	const current_language: TextsProps = useSelector((state: any) => state.configs.current_language);
	let photo = useSelector((state: any) => state.add_pac_aval.photo);

	const management_data = useSelector((state:any)=> state.dashboard.management_data);
	const entrance_door_data = useSelector((state:any)=> state.dashboard.entrance_door_data);

	const companiesAdded = ['demo', 'arcelor']
	const { company } = useParams<any>();

	const conditioning = [
		"",
		current_language?.menu_lateral_atleta,
		current_language?.menu_lateral_ativo,
		current_language?.menu_lateral_pos_operatorio,
		current_language?.menu_lateral_sedentario,
		current_language?.menu_lateral_idoso,
	];
	const Sex = [
		current_language?.options_sexo_mas,
		current_language?.options_sexo_fem,
	];
	const DominantSides = [
		current_language?.canhoto,
		current_language?.destro,
	];

	const [isMobile, setIsMobile] = useState(
		typeof window !== 'undefined' && window.innerWidth <= 767
	);
	const [windowHeight, setWindowHeight] = useState(window.innerHeight);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	const [firstStep, setFirstStep] = useState(true);
	const [secondStep, setSecondStep] = useState(false);
	const [thirdStep, setThirdStep] = useState(false);
	const [fourthStep, setFourthStep] = useState(false);
	const [fifthStep, setFifthStep] = useState(false);
	const [sixthStep, setSixthStep] = useState(false);
	const [condition, setCondition] = useState<string>("");
	const [dominant, setDominant] = useState<string>("");
	const [optionChecked, setOptionChecked] = useState<string>("");
	const [rolesCompany, setRolesCompany] = useState<any>([])
	const [rolesCompanyForFilter, setRolesCompanyForFilter] = useState<any>([])
	const [roleCompany, setRoleCompany] = useState<any>({});
	const [idNewPatient, setIdNewPatient] = useState<any>(null)
	const [loading, setLoading] = useState<boolean>(false);
	const [manager, setManager] = useState<any>();
	const [openDoor, setOpenDoor] = useState<any>();
	const [managementList, setManagementList] = useState([]);
	const [entranceDorList, setEntranceDorList] = useState([]);

	const getRolesCompany = async (company: string) => {
		const config = {
			headers: {
				"Content-Type": "application/json",
			},
		};
		const URL =  window.location.hostname === 'localhost'
			? 'https://homologacao.api7.kinology.com.br/v7/syncs/async/cargos'
			: 'https://api7.kinology.com.br/v7/syncs/async/cargos'

		const data_request = {
			company: company,
		};

		try{
			const { data } = await axios.post(
				URL,
				data_request,
				config
			);

			if(data?.code === 0 && data?.cargos?.length > 0) {
				data.cargos.map((cargo: any) => {
					setRolesCompany((prev: any) => [
						...prev,
						cargo.CARGO_TITULO
					]);
					setRolesCompanyForFilter((prev: any) => [
						...prev,
						{...cargo}
					]);
				})
			}
		}catch(error){
			sendErrorSentryOrLocalHost(error,{
				message: 'Erro ao buscar cargos  - GetRolesCompany',
				tags: {
					endpoint: window.location.hostname === 'localhost'
					? 'https://homologacao.api7.kinology.com.br/v7/syncs/async/cargos'
					: 'https://api7.kinology.com.br/v7/syncs/async/cargos', 
					file: 'src/pages/Acesso/CadastroPacienteAsync/index.tsx' 
				},
			})
		}
	}

	const handleSendTerm = async () => {		
		const config = {
			headers: {
				"Content-Type": "application/json",
			},
		};
		const URL =  window.location.hostname === 'localhost'
			? 'https://homologacao.api7.kinology.com.br/v7/termos/async/consentimento_responder'
			: 'https://api7.kinology.com.br/v7/termos/async/consentimento_responder'

		const data_request = {
			txDataHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),
			ID_PACIENTE: idNewPatient,
			RESPOSTA_CONSENTIMENTO: optionChecked === 'accepted' && 1 || 0,
			company: company
		};

		try{
			const { data } = await axios.post(
				URL,
				data_request,
				config
			);

			AmplitudeLog("termo_assincrono", {
				body: {
					...data_request
				},
			});
		}catch(error){
				sendErrorSentryOrLocalHost(error,{
					message: 'Erro ao enviar termo  - handleSendTerm',
					tags: {
						endpoint: window.location.hostname === 'localhost'
						? 'https://homologacao.api7.kinology.com.br/v7/termos/async/consentimento_responder'
						: 'https://api7.kinology.com.br/v7/termos/async/consentimento_responder', 
						file: 'src/pages/Acesso/CadastroPacienteAsync/index.tsx' 
					},
				})
		} finally {
			setFifthStep(false)
			setSixthStep(true)
		}
	};

		useEffect(()=>{
		if(management_data?.gerencias?.length > 0 ){
			const ManagementName = management_data?.gerencias?.map((item: any)=> item?.GERENCIA_TITULO)
			setManagementList(ManagementName);
		}
		if(entrance_door_data?.portas_entrada?.length > 0 ){
			const doorList = entrance_door_data?.portas_entrada?.map((item: any)=> item?.PORTA_ENTRADA_TITULO)
			setEntranceDorList(doorList);
		}
	},[management_data, entrance_door_data])

	const onSubmit = async (data: FieldValues) => {
		setLoading(true);
		if (photo === undefined) {
			photo = "";
		}

		const config = {
			headers: {
				"Content-Type": "application/json",
			},
		};
		const URL =  window.location.hostname === 'localhost'
			? 'https://homologacao.api7.kinology.com.br/v7/usuarios/async/paciente_adicionar'
			: 'https://api7.kinology.com.br/v7/usuarios/async/paciente_adicionar'

		const dat_request = {
			txDataHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),
			company: company,
			USUARIO_NIVEL: "3",
			USUARIO_NOME: data?.nome,
			USUARIO_EMAIL: data?.email,
			USUARIO_CONTATO: data?.celular,
			USUARIO_FOTO: photo,
			USUARIO_CPF: data?.cpf,
			USUARIO_ESTATURA: data?.altura,
			USUARIO_MASSA: data?.massa,
			USUARIO_NASCIMENTO:
				current_language?.idioma === "Português"
					? data?.birth_date?.split("/").reverse().join("-")
					: current_language?.idioma === "English"
					? `${data?.birth_date?.substr(6, 10)}-${data?.birth_date
							?.substr(0, 5)
							.split("/")
							.reverse()
							.join("-")}`
					: data?.data.split("-").reverse().join("-"),
			USUARIO_SEXO: data?.gender?.length > 0 ? data?.gender.charAt(0) === "M" ? "M" : "F" : "",
			USUARIO_CONDICIONAMENTO: data?.conditioning,
			USUARIO_LADO_DOMINANTE: 
			(!data.LadoDominanteSup || data.LadoDominanteSup === current_language?.lado_dominante) ? ""
				: formatDominantForSave(data.LadoDominanteSup, current_language),
			USUARIO_LADO_DOMINANTE_INF: 
			(!data.LadoDominanteInf || data.LadoDominanteInf === current_language?.lado_dominante) ? ""
				: formatDominantForSave(data.LadoDominanteInf, current_language),
			ID_CARGO: !!roleCompany && rolesCompanyForFilter.filter((role: any) => role.CARGO_TITULO === roleCompany)[0]?.ID_CARGO || null,
			USUARIO_MATRICULA: data?.conditioning,
			...(openDoor && {ID_PORTA_ENTRADA: openDoor}),
			...(manager && {ID_GERENCIA: openDoor}),
		};
		try{
			const { data } = await axios.post(
				URL,
				dat_request,
				config
			);

			if(data?.code === 0) {
				setIdNewPatient(data?.ID_USUARIO)
				setFourthStep(false)
				setFifthStep(true)
				AmplitudeLog("adicionar_paciente_assincrono", {
					body: {
						...dat_request
					},
				});
				dispatch(
					AppActions.set_toast_visible({
						status_toast: true,
						type_toast: TypesErrorRequest.SUCCESS,
						message_toast: 'Cadastro realizado com sucesso.',
					})
				)
				setFourthStep(false)
				setFifthStep(true)
			}
		}catch(error){
			dispatch(
			AppActions.set_toast_visible({
				status_toast: true,
				type_toast: TypesErrorRequest.FAIL,
				message_toast: 'Erro realizar o cadastro, tente novamente.',
			}))
			sendErrorSentryOrLocalHost(error,{
				message: 'Erro ao cadastradar paciente asyncrono - onSubmit',
				tags: {
					endpoint: window.location.hostname === 'localhost'
					? 'https://homologacao.api7.kinology.com.br/v7/usuarios/async/paciente_adicionar'
					: 'https://api7.kinology.com.br/v7/usuarios/async/paciente_adicionar', 
					file: 'src/pages/Acesso/CadastroPacienteAsync/index.tsx' 
				},
			})
		} finally {
			setLoading(false);
		}

	};

	useEffect(() => {
		AmplitudeLog('Iniciou Cadastro', {body: {Origem: 'Async'}})
		setRolesCompany([]);
		getRolesCompany(company);
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 1400);
			setWindowHeight(window.innerHeight);
			setWindowWidth(window.innerWidth);
		};
	
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [])
	useEffect(()=>{
		if(!!fifthStep){
				AmplitudeLog('Termo_de_consentimento_viu', {body: {Origem: 'Async'}})
		}
	},[fifthStep])

	useEffect(() => {
		if (!companiesAdded.includes(company)) history.push( "/dashboard" )
		dispatch(DashBoardActions.set_current_company(company));
	}, [company])

	return (
		<>
			{(!!isMobile || windowWidth <= 1400) && !firstStep && (
				<Header>
					<img src={LogoHeader} alt="logo" className="logo"  />
				</Header>
			)}
			<Conteiner>
				<Background>
					<img src={BackgroundRegister} alt=""  width={'100%'} height={'100%'}/>
				</Background>
				<Margem windowHeight={!!firstStep && 120 || !!sixthStep && 87 || windowHeight >= 730 && 70 || 60} style={{
					width: '100%'
				}}>
					<Content style={{
						width: '100%',
					}}>
						{(!!secondStep || !!thirdStep || !!fourthStep) && (
							<>
								<Text 
									title={current_language?.cadastrar}
									fontFamily="NotoSans-Bold"
									fontSize={1.2}
									textColor={Colors.primary_blue_k_main}
									textAlign={(!isMobile || windowWidth >= 992) && "left" || "center"}
									marginTop={(!isMobile || windowWidth >= 992) && 45 || 5}
								/>
								<Text 
									title={current_language?.preencha_informacoes}
									fontFamily="NotoSans-Regular"
									fontSize={(!isMobile || windowWidth >= 992) && 1.5 || 1}
									fontWeight={400}
									textColor={Colors.primary_blue_k_main+70}
									textAlign={(!isMobile || windowWidth >= 992) && "left" || "center"}
									marginTop={15}
									marginBottom={40}
								/>
							</>
						)}
						<Form methods={methods} onSubmit={(data)=>{onSubmit(data)}}>
							{!!firstStep && (
								<>
									<img src={LogoLogin} alt="logo" className="logo" style={{ width:303, marginTop: (!isMobile || windowWidth >= 992) && '10rem' || 0, 
										display: 'block',  marginLeft: 'auto', marginRight: 'auto' }} />
									<Text 
										title={current_language?.boas_vindas}
										fontFamily="NotoSans-Regular"
										fontSize={1.8}
										textColor={Colors.primary_blue_k_main}
										textAlign="center"
										marginTop={40}
									/>
									<Text
										firstSpan={`"${current_language?.exame_forca}"`}
										secondSpan={company === 'arcelor' && 'ArcelorMittal.' || 'Kinology' }
										title={"Realize o cadastro para poder realizar o"}
										title2={"pedido pela"}
										fontFamily="NotoSans-Regular"
										fontSize={1.8}
										textColor={Colors.primary_blue_k_main}
										textAlign="center"
										marginBottom={70}
									/>
									<ButtonFooter>
										<FormSubmiteButton
											type="submit"
											onClick={()=> {
												setFirstStep(false)
												setSecondStep(true)
												dispatch(DashBoardActions.sync_gerencias_request());
												dispatch(DashBoardActions.sync_porta_entrada_request());
											}}
											disabled={false}
											fontFamily="Kanit-Medium"
											typeButtonComponent="primary"
											title={current_language?.iniciar}
										/>
									</ButtonFooter>
								</>
							) || !!secondStep && (
								<>
									<FotoPerfil />
									<InputTextEntryForm 
										type="text"
										width={100}
										title={current_language?.nome_completo + '*'}
										placeholder={current_language?.placeholder_digite}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										typeInputName="nome"
										marginTop={15}
									/>
									{!isMobile && (
										<ContainerTwoLabels>
											<InputTextEntryForm 
												type="number"
												width={48.5}
												title={'CPF*'}
												placeholder={'__.__.__-_'}
												leftIcon="DigitalIcon"
												fontFamily="NotoSans-SemiBold"
												fontWeight={600}
												typeInputName="cpf"
												maxLength={14}
												marginTop={15}
											/>
											<InputTextEntryForm 
												type="text"
												width={48.5}
												title={`${current_language?.menu_lateral_data_nascimento} *`}
												placeholder={'21/01/2016'}
												leftIcon="Calendar"
												fontFamily="NotoSans-SemiBold"
												fontWeight={600}
												typeInputName="birth_date"
												maxLength={10}
												marginTop={15}
											/>
										</ContainerTwoLabels>
									) || (
										<>
											<InputTextEntryForm 
												type="number"
												width={100}
												title={'CPF*'}
												placeholder={'__.__.__-_'}
												leftIcon="DigitalIcon"
												fontFamily="NotoSans-SemiBold"
												fontWeight={600}
												typeInputName="cpf"
												maxLength={14}
												marginTop={15}
											/>
											<InputTextEntryForm 
												type="text"
												width={100}
												title={`${current_language?.menu_lateral_data_nascimento} *`}
												placeholder={'21/01/2016'}
												leftIcon="Calendar"
												fontFamily="NotoSans-SemiBold"
												fontWeight={600}
												typeInputName="birth_date"
												maxLength={10}
												marginTop={15}
											/>
										</>
									)}
									<InputTextEntryForm 
										type="number"
										width={100}
										title={`${current_language?.primeiro_acesso_celular} (${current_language?.opcional})`}
										placeholder={'( ) 00000-0000'}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										leftIcon="Phone"
										marginTop={15}
										typeInputName="celular"
										maxLength={15}
									/>
									<InputTextEntryForm 
										type="text"
										width={100}
										title={`E-mail (${current_language?.opcional})`}
										placeholder={current_language?.placeholder_digite}
										leftIcon="EmailIcon"
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										marginTop={15}
										typeInputName="email" 
									/>
									<ButtonFooter>
										<FormSubmiteButton
											type="submit"
											onClick={()=> {
												setSecondStep(false)
												setThirdStep(true)
											}}
											disabled={Object.values([methods.watch()?.nome, methods.watch()?.cpf, methods.watch()?.birth_date]).every((item: string)=> item != '')
												? false
												: true
											}
											marginTop={40}
											fontFamily="Kanit-Medium"
											typeButtonComponent="primary"
											activityIndicator={!!aprovado}
											title={current_language?.menu_lateral_botao_avancar}
										/>
									</ButtonFooter>
								</>
							) || !!thirdStep && (
								<>
									<InputSelectForm 
										type="select"
										width={100}
										title={`${current_language?.cargo} (${current_language?.opcional})`}
										placeholder={current_language?.select_country}
										leftIcon="RoleIcon"
										rightIcon="ArrowSelect"
										arrayOptions={rolesCompany}
										fontFamily="NotoSans-SemiBold"
										dataChildToParent={(data) => {
											setRoleCompany(data);
										}}
										fontWeight={600}
										marginTop={24}
										typeInputName="RolesCompany" 
									/>
									<InputTextEntryForm 
										type="text"
										width={100}
										title={`${current_language?.matricula} (${current_language?.opcional})`}
										placeholder={current_language?.placeholder_digite}
										leftIcon="InscriptionIcon"
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										marginTop={15}
										typeInputName="inscriptionField"
									/>
									<InputSelectForm 
										type="select"
										width={100}
										title={`${current_language?.porta_entrada} (${current_language?.opcional})`}
										placeholder={current_language?.escolha_uma_opcao_ass }
										leftIcon="DoorOpen"
										rightIcon="ArrowSelect"
										arrayOptions={entranceDorList}
										fontFamily="NotoSans-SemiBold"
										dataChildToParent={(data) => {
											const selectObjetValue = entrance_door_data?.portas_entrada?.find((item: any)=> item?.PORTA_ENTRADA_TITULO == data)
											setOpenDoor(selectObjetValue?.ID_PORTA_ENTRADA)
										}}
										fontWeight={600}
										marginTop={24}
										typeInputName="OpenDoor" 
									/>
									<InputSelectForm 
										type="select"
										width={100}
										title={`${current_language?.gerencia} (${current_language?.opcional})`}
										placeholder={current_language?.escolha_uma_opcao_ass }
										leftIcon="Constructor"
										rightIcon="ArrowSelect"
										arrayOptions={managementList}
										fontFamily="NotoSans-SemiBold"
										dataChildToParent={(data) => {
											const selectObjetValue = management_data?.gerencias?.find((item: any)=> item?.GERENCIA_TITULO == data)
											setManager(selectObjetValue?.ID_GERENCIA)
										}}
										fontWeight={600}
										marginTop={24}
										typeInputName="Manager" 
									/>
									
									<ButtonFooter>
										<FormSubmiteButton
											type="submit"
											onClick={()=> {
												setThirdStep(false)
												setFourthStep(true)
											}}
											disabled={false}
											marginTop={ (!isMobile || windowWidth >= 992) && 40 || 4}
											fontFamily="Kanit-Medium"
											typeButtonComponent="primary"
											activityIndicator={!!aprovado}
											title={current_language?.menu_lateral_botao_avancar}
										/>
										<FormSubmiteButton
											disabled={false}
											typeButtonComponent={ (!isMobile || windowWidth >= 992) && "primary" || "secondary"}
											title={current_language?.voltar}
											fontFamily="Kanit-Medium"
											marginTop={4}
											textColor={Colors.primary_blue_k_main}
											bgColor={"transparent"}
											width={100}
											onClick={()=>{
												setSecondStep(!!thirdStep ? true : false)
												setThirdStep(!!thirdStep ? false : true)
												setFourthStep(!!fourthStep ? false : true)
												setFifthStep(!!fifthStep ? false : true)
											}}
										/>
									</ButtonFooter>
								</>
							) || !!fourthStep && (
								<>
									<InputTextEntryForm
										type="text"
										title={current_language?.menu_lateral_massa}
										placeholder={current_language?.placeholder_digite}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										fontSize={1}
										leftIcon="Mass"
										typeInputName="massa"
										maxLength={6}
									/>
									<InputTextEntryForm
										type="text"
										marginTop={20}
										title={current_language?.menu_lateral_altura}
										placeholder={current_language?.placeholder_digite}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										fontSize={1}
										leftIcon="Height"
										typeInputName="altura"
										maxLength={4}
									/>
									<InputSelectForm
										type="select"
										title={current_language?.menu_lateral_sexo}
										placeholder={current_language?.selecione}
										rightIcon="ArrowSelect"
										arrayOptions={Sex}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										marginTop={20}
										fontSize={1}
										typeInputName="gender"
									/>
									<InputSelectForm
										type="select"
										title={current_language?.menu_lateral_condicionamento}
										placeholder={current_language?.selecione}
										rightIcon="ArrowSelect"
										arrayOptions={conditioning}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										fontSize={1}
										dataChildToParent={(data) => {
											setCondition(data);
										}}
										marginTop={20}
										typeInputName="conditioning"
									/>
									<InputSelectForm
										type="select"
										title={current_language?.lado_dominante_superiores}
										descriptionTitle={current_language?.lado_mao}
										placeholder={current_language?.selecione}
										rightIcon="ArrowSelect"
										arrayOptions={DominantSides}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										fontSize={1}
										marginTop={20}
										typeInputName="LadoDominanteSup"
										dataChildToParent={(data) => {
											setDominant(data);
										}}
									/>
									<InputSelectForm
										type="select"
										title={current_language?.lado_dominante_inferiores}
										descriptionTitle={current_language?.lado_perna}
										placeholder={current_language?.selecione}
										rightIcon="ArrowSelect"
										arrayOptions={DominantSides}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										fontSize={1}
										marginTop={20}
										typeInputName="LadoDominanteInf"
										dataChildToParent={(data) => {
											setDominant(data);
										}}
									/>
									<ButtonFooter>
										<FormSubmiteButton
											type="submit"
											onClick={()=> {
												methods.trigger();
												AmplitudeLog('Concluiu Cadastro', {
													body: {
														Origem: 'Async', 
														Foto: photo ? 'Sim' : 'Não', 
														Cargo: !!roleCompany  ?  rolesCompanyForFilter?.find((role: any) => role.CARGO_TITULO === roleCompany)?.CARGO_TITULO : 'Cargo não especificado'
													}
												})
											}}
											disabled={false}
											marginTop={(!isMobile || windowWidth >= 992) && 40 || 4}
											fontFamily="Kanit-Medium"
											typeButtonComponent="primary"
											activityIndicator={!!aprovado}
											title={!loading && current_language?.menu_lateral_botao_avancar || current_language?.loading}
										/>
										<FormSubmiteButton
											disabled={false}
											typeButtonComponent={(!isMobile || windowWidth >= 992) && "primary" || "secondary"}
											title={current_language?.voltar}
											fontFamily="Kanit-Medium"
											marginTop={4}
											textColor={Colors.primary_blue_k_main}
											bgColor={"transparent"}
											width={100}
											onClick={()=>{
												setSecondStep(!!secondStep ? false : false)
												setThirdStep(!!thirdStep ? false : true)
												setFourthStep(!!fourthStep ? false : true)
												setFifthStep(!!fifthStep ? false : true)
											}}
										/>
									</ButtonFooter>
								</>
							) || !!fifthStep && (
								<>
									<Text
										title={current_language?.termo_consentimento_livre_esclarecido} 
										fontFamily='NotoSans-Regular'
										fontSize={1.5}
										textColor={Colors.primary_blue_k_main}
										fontWeight={700}
										marginTop={(!isMobile || windowWidth >= 992) && 30 || 0}
									/>
									<Text
										title={current_language?.termo_deve_ser_lido}
										fontFamily="NotoSans-Regular"
										fontSize={0.9}
										textColor={Colors.primary_blue_k_main}
										marginTop={20}
									/>
									<div style={{
										marginTop: '2rem',
										paddingLeft: '2rem',
										paddingRight: '2rem',
										border: '1px solid gray',
										borderRadius: 10,
										height: (!isMobile || windowWidth >= 992) && '40%' || '25%',
										overflowY: 'scroll'
									}}>
										<Text
											title={current_language?.projeto_avaliacao_osteomuscular}
											fontFamily="NotoSans-Regular"
											fontSize={1.2}
											textColor={Colors.primary_blue_k_main}
											fontWeight={700}
											marginTop={20}
										/>
										<Text
											title={current_language?.objetivo_documento}
											fontFamily="NotoSans-Regular"
											fontSize={0.9}
											textColor={Colors.neutral_grey_k_70}
											fontWeight={500}
											marginTop={10}
											textAlign="left"
										/>
										<Text
											title={current_language?.procedimentos}
											fontFamily="NotoSans-Regular"
											fontSize={1.2}
											textColor={Colors.primary_blue_k_main}
											fontWeight={700}
											marginTop={10}
										/>
										<Text
											title={`1. ${current_language?.questionario_triagem}`}
											fontFamily="NotoSans-Regular"
											fontSize={0.9}
											textColor={Colors.neutral_grey_k_70}
											fontWeight={500}
											marginTop={10}
											textAlign="left"
										/>
										<Text
											title={`2. ${current_language?.questionario_auto_declaracao}`}
											fontFamily="NotoSans-Regular"
											fontSize={0.9}
											textColor={Colors.neutral_grey_k_70}
											fontWeight={500}
											marginTop={10}
											textAlign="left"
										/>
										<Text
											title={`3. ${current_language?.protocolo_avaliacao}`}
											fontFamily="NotoSans-Regular"
											fontSize={0.9}
											textColor={Colors.neutral_grey_k_70}
											fontWeight={500}
											marginTop={10}
											textAlign="left"
										/>
										<Text
											title={`4. ${current_language?.formulario_eva}`}
											fontFamily="NotoSans-Regular"
											fontSize={0.9}
											textColor={Colors.neutral_grey_k_70}
											fontWeight={500}
											marginTop={10}
											textAlign="left"
										/>
										<Text
											title={current_language?.riscos_beneficios}
											fontFamily="NotoSans-Regular"
											fontSize={1.2}
											textColor={Colors.primary_blue_k_main}
											fontWeight={700}
											marginTop={10}
										/>
										<Text
											title={`- ${current_language?.riscos}`}
											fontFamily="NotoSans-Regular"
											fontSize={0.9}
											textColor={Colors.neutral_grey_k_70}
											fontWeight={500}
											marginTop={10}
											textAlign="left"
										/>
										<Text
											title={`- ${current_language?.beneficios}`}
											fontFamily="NotoSans-Regular"
											fontSize={0.9}
											textColor={Colors.neutral_grey_k_70}
											fontWeight={500}
											marginTop={10}
											textAlign="left"
										/>
										<Text
											title={current_language?.participacao_voluntaria}
											fontFamily="NotoSans-Regular"
											fontSize={1.2}
											textColor={Colors.primary_blue_k_main}
											fontWeight={700}
											marginTop={15}
										/>
										<Text
											title={current_language?.participacao_voluntaria_texto}
											fontFamily="NotoSans-Regular"
											fontSize={0.9}
											textColor={Colors.neutral_grey_k_70}
											marginTop={10}
											marginBottom={10}
											textAlign="left"
										/>			
									</div>
									<ButtonFooter>
										<Text
											title={current_language?.declaro_que_li}
											fontFamily="NotoSans-Regular"
											fontSize={0.9}
											textColor={Colors.primary_blue_k_main}
											fontWeight={700}
											marginTop={(!isMobile || windowWidth >= 992) && 25 || 5}
										/>
										<div style={{ display: 'flex', justifyContent: 'center', gap: '40px', alignItems: 'center', marginTop: '2rem' }}>
											<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
												<RadioButton
													type="radio"
													name="term_accept"
													onChange={() => setOptionChecked('accepted')}
													checked={optionChecked === 'accepted'}
												/>
												<Text
													title={current_language?.quero_participar}
													fontFamily="NotoSans-Regular"
													onClick={() => setOptionChecked('accepted')}
													fontSize={0.9}
													textColor={Colors.primary_blue_k_main}
													fontWeight={700}
												/>
											</div>

											<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
												<RadioButton
													type="radio"
													name="term_decline"
													onChange={() => setOptionChecked('declined')}
													checked={optionChecked === 'declined'}
												/>
												<Text
													title={current_language?.nao_quero_participar}
													onClick={() => setOptionChecked('declined')}
													fontFamily="NotoSans-Regular"
													fontSize={0.9}
													textColor={Colors.primary_blue_k_main}
													fontWeight={700}
												/>
											</div>
										</div>
										<FormSubmiteButton
											type="button"
											onClick={()=>{ handleSendTerm(), AmplitudeLog('termo_de_consentimento_enviou', {body: {Origem: 'async', Autorização: optionChecked === 'accepted' ? 'Sim' : 'Não'}})} }
											disabled={optionChecked.length > 0 ? false : true}
											marginTop={(!isMobile || windowWidth >= 992) && 40 || 15}
											fontFamily="Kanit-Medium"
											typeButtonComponent="primary"
											activityIndicator={!!aprovado}
											title={current_language?.finalizar_cadastro}
										/>
										<FormSubmiteButton
											disabled={false}
											typeButtonComponent={(!isMobile || windowWidth >= 992) && "primary" || "secondary"}
											title={current_language?.voltar}
											fontFamily="Kanit-Medium"
											marginTop={4}
											textColor={Colors.primary_blue_k_main}
											bgColor={"transparent"}
											width={100}
											onClick={()=>{
												setFourthStep(true)
												setFifthStep(false)
											}}
										/>
									</ButtonFooter>
								</>
							) || !!sixthStep && (
								<>
									<Text 
										title={current_language?.cadastro_sucesso_async}
										fontFamily="NotoSans-Bold"
										fontSize={1.2}
										textColor={Colors.primary_blue_k_main}
										textAlign="center"
										marginTop={(!isMobile || windowWidth >= 992) && 65 || 10}
									/>
									<div style={{
										background: '#FFD58066',
										borderRadius: '18.5px'
									}}>
										<Text
											firstSpan={`${current_language?.tag_atencao}:`}
											secondSpan={current_language?.risco_reagendamento_exame}
											title={current_language?.siga_recomendacoes}
											fontFamily="NotoSans-Regular"
											fontSize={1}
											textColor={Colors.neutral_grey_k_80}
											textAlign="left"
											marginTop={45}
											fontWeight={100}
											padding={1}
										/>
									</div>
									<div style={{
										display: (!isMobile || windowWidth >= 992) && 'flex' || 'grid',
										justifyContent: (!isMobile || windowWidth >= 992) && 'space-around' || 'center',
										marginTop: '1.2rem'
									}}>
										<div style={{
											borderRadius: '18.5px',
											border: 'red 1px solid',
											width: '202px',
											marginTop: '1.2rem'
										}}>
											<img src={Exercicio} alt="exercicio" className="exercicio" 
												style={{ 
													width: 200, 
													height: 210, 
													marginLeft: 'auto', 
													marginRight: 'auto', 
													borderTopRightRadius: '18.5px',
													borderTopLeftRadius: '18.5px'
											}} />
											<div style={{
												padding: '1rem'
											}}>
												<Text 
													title={current_language?.horas_antes_exame}
													fontFamily="NotoSans-Bold"
													fontSize={1}
													textColor={Colors.primary_blue_k_main}
													textAlign="center"
													textDecoration="underline"
												/>
												<Text
													firstSpan={current_language?.sem_dados_disponiveis.split(" ")[0].toLocaleUpperCase()}
													title={current_language?.exercicios_fisicos_regioes}
													fontFamily="NotoSans-Regular"
													fontSize={1}
													textColor={Colors.primary_blue_k_main}
													textAlign="center"
													fontWeight={100}
												/>
											</div>
										</div>
										<div style={{
											borderRadius: '18.5px',
											border: 'red 1px solid',
											width: '202px',
											marginTop: '1.2rem'
										}}>
											<img src={Cafe} alt="cafe" className="cafe" 
												style={{ 
													width: 200, 
													height: 210, 
													marginLeft: 'auto', 
													marginRight: 'auto', 
													borderTopRightRadius: '18.5px',
													borderTopLeftRadius: '18.5px'
											}} />
											<div style={{
												padding: '1rem'
											}}>
												<Text 
													title={current_language?.dia_do_exame}
													fontFamily="NotoSans-Bold"
													fontSize={1}
													textColor={Colors.primary_blue_k_main}
													textAlign="center"
													textDecoration="underline"
												/>
												<Text
													firstSpan={current_language?.not.toLocaleUpperCase()}
													title={current_language?.consumir_cafeina}
													fontFamily="NotoSans-Regular"
													fontSize={1}
													textColor={Colors.primary_blue_k_main}
													textAlign="center"
													fontWeight={100}
												/>
											</div>
										</div>
										<div style={{
											borderRadius: '18.5px',
											border: 'green 1px solid',
											width: '202px',
											marginTop: '1.2rem'
										}}>
											<img src={Roupas} alt="roupas" className="roupas" 
												style={{ 
													width: 200, 
													height: 210, 
													marginLeft: 'auto', 
													marginRight: 'auto', 
													borderTopRightRadius: '18.5px',
													borderTopLeftRadius: '18.5px'
												}} />
											<div style={{
												padding: '1rem'
											}}>
												<Text 
													title={current_language?.dia_do_exame}
													fontFamily="NotoSans-Bold"
													fontSize={1}
													textColor={Colors.primary_blue_k_main}
													textAlign="center"
													textDecoration="underline"
												/>
												<Text
													firstSpan={current_language?.usar}
													title={current_language?.roupas_leves}
													fontFamily="NotoSans-Regular"
													fontSize={1}
													textColor={Colors.primary_blue_k_main}
													textAlign="center"
													fontWeight={100}
												/>
											</div>
										</div>
									</div>
								</>
							)}
						</Form>
					</Content>
				</Margem>
			</Conteiner>
		</>
	);
};

export default memo(CadastroPacienteAsync);

